// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css'; // Import your main application CSS (if any, otherwise remove)
import { ThemeProvider } from './styles/ThemeContext';
import { Analytics } from "@vercel/analytics/react"
// Import your components
import Layout from './layouts/Layout'; // Assuming you have a Layout component
import MailinatorApp from './features/Mailinator/MailinatorApp';
import JsonToolsApp from './features/JsonTools/JsonToolsApp';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import SpatialToolsApp from './features/SpatialTools/SpatialToolsApp';
import DevToolsApp from './features/DevTools/DevToolsApp';
import ColorImageToolsApp from './features/ColorImageTools/ColorImageToolsApp';
import ApiToolsApp from './features/ApiTools/ApiToolsApp';
import TextToolsApp from './features/TextTools/TextToolsApp';
import BlogApp from './features/Blog/BlogApp';
import BlogPost from './features/Blog/BlogPost';
import GalileoPet from './components/GalileoPet';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        {/* The Layout component will wrap all its child routes */}
        <Routes>
          {/* Redirect from root ("/") to "/home" */}
          <Route path="/" element={<Navigate to="/home" replace />} />

          {/* Routes with the standard Layout component */}
          <Route element={<Layout />}>
            <Route path="/home" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<BlogApp />} />
            <Route path="/blog/:postId" element={<BlogPost />} />
            {/* Fallback route for 404 pages */}
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Routes with the minimal Layout for full-screen apps */}
          <Route element={<Layout minimal />}>
            <Route path="/about" element={<About />} />
            <Route path="/mailinator/*" element={<MailinatorApp />} />

            <Route path="/json-tools/*" element={<JsonToolsApp />} />
            <Route path="/json-viewer-app" element={<Navigate to="/json-tools" replace />} />

            <Route path="/spatial-tools/*" element={<SpatialToolsApp />} />
            <Route path="/spatial-tools-app" element={<Navigate to="/spatial-tools" replace />} />

            <Route path="/api-tools/*" element={<ApiToolsApp />} />

            <Route path="/text-tools/*" element={<TextToolsApp />} />
            <Route path="/text-tools-app" element={<Navigate to="/text-tools" replace />} />

            <Route path="/dev-tools/*" element={<DevToolsApp />} />
            <Route path="/dev-tools-app" element={<Navigate to="/dev-tools" replace />} />

            <Route path="/color-image-tools/*" element={<ColorImageToolsApp />} />
          </Route>

        </Routes>
        <Analytics />
        <GalileoPet />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;

